import { render, staticRenderFns } from "./ProviderHoverComponent.vue?vue&type=template&id=19b7a9bb"
import script from "./ProviderHoverComponent.vue?vue&type=script&lang=js"
export * from "./ProviderHoverComponent.vue?vue&type=script&lang=js"
import style0 from "./ProviderHoverComponent.vue?vue&type=style&index=0&id=19b7a9bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports